import { useHeaderHeight } from "@roc/feature-app-core";


export const useEarningsCardSticky = () => {
  const headerHeight = useHeaderHeight();
  const earningsCardsStickyStyle: React.CSSProperties = {
    position: "sticky",
    top: headerHeight,
    background: "#fff",
    zIndex: 1000,
    boxShadow: '0 4px 12px -2px rgba(69, 69, 127, 0.12), 0 2px 4px -2px rgba(69, 69, 127, 0.08)',
    padding: 0,
    paddingBottom: 0,
    margin: 8,
    borderRadius: 16,
  };
  return { earningsCardsStickyStyle };
};